"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Struct = _interopRequireDefault(require("../codec/Struct"));

var _Block = _interopRequireDefault(require("../type/Block"));

var _Justification = _interopRequireDefault(require("../type/Justification"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name SignedBlock
 * @description
 * A [[Block]] that has been signed and contains a [[Justification]]
 */
class SignedBlock extends _Struct.default {
  constructor(value) {
    super({
      block: _Block.default,
      justification: _Justification.default
    }, value);
  }
  /**
   * @description The wrapped [[Block]]
   */


  get block() {
    return this.get('block');
  }
  /**
   * @description Block/header [[Hash]]
   */


  get hash() {
    return this.block.hash;
  }
  /**
   * @description The wrapped [[Justification]]
   */


  get justification() {
    return this.get('justification');
  }

}

exports.default = SignedBlock;